<template>
  <el-select class="td_select"
             v-model="values"
             value-key="value"
             default-first-option
             filterable
             remote
             reserve-keyword
             placeholder="请输入关键词"
             :clearable="clearable"
             :disabled="disabled"
             :filter-method="filterMethod"
             @clear="clearAction"
             :loading="loading">
    <el-option
        class="td_option"
        v-for="(item, index) in options"
        :key="index"
        :label="item.arap+ '  ' +item.arapNo"
        :value="{ value: item.arap, label: item.arapNo }"
        @click.native="handleSelect(item)">
      <span style="float: left;"><i class="fa fa-gg-circle" :style="{'color':item.arapType==='收入'?'#f78989':'#66b1ff','margin-right': '5px'}"></i>{{ item.arap }}</span>
      <span style="float: left; margin-left: 20px; color: #8492a6; font-size: 13px;">{{ item.arapNo }}</span>
    </el-option>
  </el-select>
</template>
<script>
// 应收账单 收支大类 编辑界面 码+名称
import { validatenull } from '@/tdcommon/validate'
// import { getdict } from '@/api/admin/dict'
// import { getFeeType } from '@/api/tms/tmstransaction'

export default {
  name: 'd2-income-edit',
  data () {
    return {
      values: {},
      options: [],
      copyOptions: [],
      loading: false,
      mdmStrMark: ''
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    sourcetype: {
      type: String,
      default: () => ''
    },
    mdmstr: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    remoteMethod (query) {
      // this.loading = true
      // getFeeType().then(response => {
      //   if (response.code === 0) {
      //     this.loading = false
      //     this.options = response.data.filter(item => item.arapType === '收入')
      //     this.copyOptions = response.data.filter(item => item.arapType === '收入')
      //   }
      // }).catch(() => {
      //   this.loading = false
      // })
      // getdict('fee_type_code').then(response => {
      //   if (response.code === 0) {
      //     this.loading = false
      //     this.options = response.data.filter(item => item.description === '收入')
      //     this.copyOptions = response.data.filter(item => item.description === '收入')
      //   }
      // }).catch(() => {
      //   this.loading = false
      // })
    },
    // 自定义搜索
    async filterMethod (val) {
      this.options = []
      if (!validatenull(val)) {
        this.copyOptions.filter(item => {
          if (String(item.arapNo).includes(val) || String(item.arap).includes(val)) {
            this.options.push(item)
          }
        })
      } else {
        this.options = this.copyOptions
      }
    },
    clearAction () {
      this.options = []
      this.options = this.copyOptions
    },
    handleSelect (val) {
      this.values = { value: val.arap, label: val.arapNo }
      this.$emit('change', val)
    },
    getStartValues (val) {
      if (!validatenull(this.mdmstr)) {
        let model = this.$parent.elForm.model[this.mdmstr]
        if (!validatenull(model)) {
          this.values = Object.assign({ value: model, label: val })
        } else {
          this.values = Object.assign({ value: '', label: val })
        }
      }
    }
  },
  watch: {
    values: function (val, oldVal) {
      // 编辑界面值是 val.label
      this.$emit('input', validatenull(val) ? '' : val.label)
    },
    value: function (val, oldVal) {
      if (!validatenull(this.options) && val !== oldVal) {
        this.remoteMethod(val)
        this.getStartValues(val)
      }
    }
  },
  mounted () {
    this.remoteMethod(this.value)
    this.getStartValues(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-income-edit/index.vue"
}
</vue-filename-injector>
